import CancelLoad from "./CancelLoad";

export default CancelLoad;